import { render, staticRenderFns } from "./PageFields.vue?vue&type=template&id=d2605206&scoped=true&"
import script from "./PageFields.vue?vue&type=script&lang=js&"
export * from "./PageFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2605206",
  null
  
)

export default component.exports